import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    background: 'white',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.08)',
    borderRadius: ({ smallMedia }) => (smallMedia ? '0' : '0.5rem'),
    maxWidth: '1610px'
  },

  container: {
    display: 'grid',
    gridTemplateColumns: '24rem minmax(0px, auto)',
    flex: 1,
    borderRadius: '0.5rem',
    flexDirection: ({ smallMedia }) => (smallMedia ? 'column' : 'row'),
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gridTemplateColumns: '1fr'
    }
  }
}))

export default useStyles
